import {takeEvery} from 'redux-saga/effects'
import {
  ADD_THREAD_PARTICIPANTS,
  BLOCK_MESSAGING_USER,
  CREATE_THREAD,
  GET_MESSAGING_ADMIN_BLOCKS,
  GET_MESSAGING_ADMIN_REPORTS,
  GET_MESSAGING_ADMIN_THREADS,
  GET_MESSAGING_CONTACTS,
  GET_MESSAGING_SETTINGS,
  GET_THREADS,
  GET_THREAD_MESSAGES,
  MUTE_THREAD,
  READ_THREAD_MESSAGES,
  REPORT_MESSAGE,
  SEARCH_MESSAGES,
  SEND_THREAD_MESSAGE,
  SET_MESSAGING_OFFICE_HOURS,
  SUSPEND_MESSAGING_USER,
  UNBLOCK_MESSAGING_USER,
  UPDATE_MESSAGING_ADMIN_REPORT,
  UPDATE_MESSAGING_SETTINGS,
} from 'setup/redux/Actions/Thread/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_THREADS, fetchData)
  yield takeEvery(CREATE_THREAD, fetchData)
  yield takeEvery(GET_THREAD_MESSAGES, fetchData)
  yield takeEvery(READ_THREAD_MESSAGES, fetchData)
  yield takeEvery(SEND_THREAD_MESSAGE, fetchData)

  // messaging module
  yield takeEvery(GET_MESSAGING_CONTACTS, fetchData)
  yield takeEvery(SEARCH_MESSAGES, fetchData)
  yield takeEvery(REPORT_MESSAGE, fetchData)
  yield takeEvery(BLOCK_MESSAGING_USER, fetchData)
  yield takeEvery(UNBLOCK_MESSAGING_USER, fetchData)
  yield takeEvery(SET_MESSAGING_OFFICE_HOURS, fetchData)
  yield takeEvery(ADD_THREAD_PARTICIPANTS, fetchData)
  yield takeEvery(MUTE_THREAD, fetchData)
  yield takeEvery(GET_MESSAGING_ADMIN_THREADS, fetchData)
  yield takeEvery(GET_MESSAGING_ADMIN_REPORTS, fetchData)
  yield takeEvery(UPDATE_MESSAGING_ADMIN_REPORT, fetchData)
  yield takeEvery(GET_MESSAGING_ADMIN_BLOCKS, fetchData)
  yield takeEvery(SUSPEND_MESSAGING_USER, fetchData)
  yield takeEvery(GET_MESSAGING_SETTINGS, fetchData)
  yield takeEvery(UPDATE_MESSAGING_SETTINGS, fetchData)
}

export default dataSaga
